<template>
    <div class="library-checkbox-group">
        <div v-if="showAllOption" class="library-checkbox-group__all-checkbox-wrapper">
            <Checkbox
                :indeterminate="someButNotAllOptionsAreSelected"
                :model-value="allOptionsAreSelected"
                @onChange="onSelectAll"
            >
                All
            </Checkbox>
        </div>

        <CheckboxGroup :model-value="modelValue" vertical @onChange="emitValues">
            <Checkbox v-for="option in options" :key="option.value" :label="option.value">
                {{ option.label }}
            </Checkbox>
        </CheckboxGroup>
    </div>
</template>

<script lang="ts">
import type { PropType } from "vue";

export default {
    props: {
        options: {
            required: true,
            type: Array as PropType<{ label: string; value: string }[]>
        },
        modelValue: {
            required: true,
            type: Array as PropType<string[]>
        }
    },

    emits: ["update:modelValue"],

    computed: {
        showAllOption() {
            return this.options.length > 1;
        },

        allOptionsAreSelected() {
            return !this.options.find(({ value }) => !this.modelValue.includes(value));
        },

        someButNotAllOptionsAreSelected() {
            return (
                !this.allOptionsAreSelected &&
                this.options.reduce((acc, { value }) => acc + (this.modelValue.includes(value) ? 1 : 0), 0) > 0
            );
        }
    },

    methods: {
        emitValues(values: string[]) {
            this.$emit("update:modelValue", values);
        },

        onSelectAll() {
            if (this.allOptionsAreSelected) {
                this.emitValues([]);
            } else {
                this.emitValues(this.options.map(({ value }) => value));
            }
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-checkbox-group__all-checkbox-wrapper {
    margin: 0 0 $spacing-small 0;
}
</style>
